import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=33bb1410&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=33bb1410&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33bb1410",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33bb1410')) {
      api.createRecord('33bb1410', component.options)
    } else {
      api.reload('33bb1410', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=33bb1410&scoped=true&", function () {
      api.rerender('33bb1410', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-26u8e383uWq7X/JS/comp/GuestBox.vue"
export default component.exports